import React from 'react'

import { Modal, Button } from '../../../../components'

const TermsAndConditionsModal = ({
  body,
  onHide,
  hasContent,
  acceptTerm,
  show,
  ...rest
}) => {
  return (
    <Modal onHide={onHide} exitOnBackdropClick={false} show={show} {...rest}>
      <Modal.Header closeButton>
        <Modal.Title>Termos de aceite</Modal.Title>
      </Modal.Header>
      <Modal.Body>{hasContent ? body : 'Nenhum termo encontrado'}</Modal.Body>
      <Modal.Footer align="center">
        {hasContent && (
          <Button
            onClick={acceptTerm}
            text="Aceitar"
            variant="primary"
            width="200px"
          />
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default TermsAndConditionsModal
